// Shared helpers for displaying per-video rotation / force-vertical, matching the
// desktop playback app. Rotation is clockwise degrees in {0, 90, 180, 270}.

export const ROTATION_VALUES = [0, 90, 180, 270]

/** Next rotation in the cycle (0 -> 90 -> 180 -> 270 -> 0). */
export function nextRotation(current) {
  return (((current || 0) % 360) + 90) % 360
}

/**
 * Inline style for the <video> element. Rotation is a CSS transform; forceVertical
 * is approximated by stretching the frame into a portrait box (objectFit: fill),
 * mirroring the desktop's width/height swap. `objectFit` is returned so callers can
 * override the default 'contain' only when forcing vertical.
 */
export function videoDisplayStyle(rotation, forceVertical) {
  const r = (((rotation || 0) % 360) + 360) % 360
  return {
    transform: r ? `rotate(${r}deg)` : undefined,
    objectFit: forceVertical ? 'fill' : 'contain',
  }
}

/** Aspect ratio to apply to the media *container* when forcing vertical. */
export function forceVerticalAspect(forceVertical) {
  return forceVertical ? '9 / 16' : undefined
}
